var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import BusinessGoodsPriceService from "../../api/BusinessGoodsPriceService";
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import { Loading } from 'element-ui';
import { tidyDataBusinessInfo } from '../../helper/newBusinessGoodsPriceFunc';
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.formData = {
            order_id: '',
            order_name: '',
            es_time: '',
            ee_time: '',
            business_info: [],
            business_info_name: '',
            order_icomment: '',
            details: [],
        };
        _this.goodParams = {
            goods_type_id: null,
            keyword: ""
        };
        _this.total = 0;
        _this.frontData = [];
        _this.rowId = '';
        _this.categoryData = [];
        return _this;
    }
    Detail.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 300;
        }, 300);
    };
    Detail.prototype.created = function () {
        this.service = BusinessGoodsPriceService.getInstance();
        this.getCategory();
        if (this.rowId) {
            this.getDetail();
        }
    };
    Detail.prototype.haveorderId = function (newValue) {
        this.getTableList();
    };
    Detail.prototype.getCategory = function () {
        var _this = this;
        this.service.getCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Detail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    Detail.prototype.search = function () {
        this.$refs.pagination.clear();
        this.getTableList();
    };
    Detail.prototype.getTableList = function (pager) {
        var _this = this;
        pager = pager ? pager : this.$refs.pagination.getPage();
        var params = {
            goods_type_id: this.goodParams.goods_type_id,
            order_id: this.rowId
        };
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getGoodList(Object.assign(this.goodParams, pager, params)).then(function (res) {
            if (res.data.success) {
                _this.frontData = Array.isArray(res.data.data) ? res.data.data : [];
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message || err.msg);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    Detail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId
        };
        this.service.getDetail(params).then(function (res) {
            var data = res.data.data;
            _this.service.getClientsByGroupTree({ is_have_empty_group: 1, is_have_shop: 1 }).then(function (res2) {
                var cgTree = res2.data.data || [];
                var res3 = tidyDataBusinessInfo(cgTree, data.supplier_to_business_ids || [], data.group_ids, data.shop_ids || []);
                data.business_info = res3.business_info;
                data.business_info_name = res3.business_info_name;
                var goods_ids = (data.details || []).map(function (good) {
                    return good.goods_id;
                });
                _this.formData = Object.assign({}, _this.formData, data);
                _this.getGoodList();
                loadingInstance.close();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message || err.msg);
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Detail.prototype.pageChange = function (pager) {
        this.getTableList(pager);
        this.$refs.table.bodyWrapper.scrollTop = 0;
    };
    Detail.prototype.getGoodList = function (pager) {
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var frontData = [];
        var startIndex = pager.start;
        var endIndex = pager.start + pager.limit - 1;
        for (var i = startIndex; i <= endIndex; i++) {
            if (!this.formData.details[i]) {
                break;
            }
            frontData.push(this.formData.details[i]);
        }
        this.frontData = frontData;
    };
    __decorate([
        Watch('formData.order_id')
    ], Detail.prototype, "haveorderId", null);
    Detail = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
            },
            methods: {}
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
